import { Ref } from 'vue';
import {
  useFormValidation,
  required,
  email,
  minLength,
  maxLength,
} from 'Helpers/form';
import { FormModelLogin } from '../models/FormModelLogin';

export function useFormValidationLogin(formModel: Ref<FormModelLogin>) {
  const rules = {
    email: {
      required,
      email,
      minLength: minLength(5),
      maxLength: maxLength(255),
    },
    password: {
      required,
      maxLength: maxLength(255),
    },
  };

  return useFormValidation(rules, formModel);
}
